var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h3',{staticClass:"title"},[_vm._v("Export code")]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.ctaText))]),_c('div',{staticClass:"actions"},[_c('an-button',{attrs:{"isWorking":_vm.isWorking},on:{"click":_vm.handleCTA}},[_vm._v(_vm._s(_vm.ctaButtonText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }